
import Vue from "vue"
import SubscriptionExpress from "@/components/subscription/SubscriptionExpress.vue"

export default Vue.extend({
  components: {
    SubscriptionExpress,
  },
  beforeCreate() {
    this.$vuetify.theme.dark = false // we force light them on this view
  },
  created() {
    document.title = this.$vuetify.lang.t("$vuetify.tab_titles.subscription_express")
  },
  data: () => ({
    show: true
  })
})
